const specialtiesItems = [
  {
    CardTitle: "Derecho Civil",
    CardDescription:
      "¿Necesitas revisar o firmar un contrato, asegurar la compra o alquiler de una propiedad o con el trámite de una herencia familiar?",
    ImageSrc: "/icos/ico-d-civil.png",
  },
  {
    CardTitle: "Derecho Penal",
    CardDescription:
      "¿Te enfrentas a un juicio penal, necesitas asesoría en una investigación policial o quieres conocer tus derechos ante una detención?",
    ImageSrc: "/icos/ico-d-penal.png",
  },
  {
    CardTitle: "Derecho Laboral",
    CardDescription:
      "¿Tienes problemas con un contrato de trabajo, fuiste despedido injustamente, necesitas asesoría en una inspección de SUNAFIL o sobre derechos laborales",
    ImageSrc: "/icos/ico-d-laboral.png",
  },
  {
    CardTitle: "Derecho Procesalista",
    CardDescription:
      "¿Quieres presentar una demanda, necesitas ayuda para defenderte en un proceso judicial, o necesitas orientación en el seguimiento de tu caso judicial?",
    ImageSrc: "/icos/ico-d-procesalista.png",
  },
  {
    CardTitle: "Derecho Administrativo",
    CardDescription:
      "¿Necesitas apoyo para gestionar trámites con entidades públicas, defenderte de una sanción o multa o resolver problemas con permisos y licencias?",
    ImageSrc: "/icos/ico-d-administrativo.png",
  },
  {
    CardTitle: "Derecho de Familia",
    CardDescription:
      "¿Estás atravesando un divorcio, buscas custodia compartida, o necesitas asesoría sobre pensiones alimenticias y acuerdos familiares?",
    ImageSrc: "/icos/ico-d-familia.png",
  },
  {
    CardTitle: "Derecho Tributario",
    CardDescription:
      "¿Necesitas ayuda con la declaración de impuestos, o defensa en fiscalización de SUNAT o en un litigio tributario?",
    ImageSrc: "/icos/ico-d-tributario.png",
  },
  {
    CardTitle: "Derecho de Migraciones",
    CardDescription:
      "¿Necesitas ayuda con trámites de residencia, permisos de trabajo, o enfrentas problemas de inmigración?",
    ImageSrc: "/icos/ico-d-migraciones.png",
  },
  {
    CardTitle: "Derecho de Poteccion al Consumidor",
    CardDescription:
      "¿Te vendieron un producto defectuoso, no cumplieron con la garantía o te han hecho cobros indebidos?",
    ImageSrc: "/icos/ico-d-consumidor.png",
  },
  {
    CardTitle: "Derecho Empresarial",
    CardDescription:
      "¿Planeas constituir una empresa, necesitas revisar contratos comerciales o estás involucrado en una fusión o disputa entre socios?",
    ImageSrc: "/icos/ico-d-empresarial.png",
  },
  {
    CardTitle: "Derecho Ambiental",
    CardDescription:
      "¿Necesitas asesoría sobre normativa ambiental, enfrentas problemas de permisos, o necesitas defensa en casos de contaminación?",
    ImageSrc: "/icos/ico-d-ambiental.png",
  },
  {
    CardTitle: "Derecho de Arbitraje y Resolución de Conflico",
    CardDescription:
      "¿Tu contrato requiere resolver un conflicto ante un árbitro o tribunal arbitral o estás considerando iniciar una mediación o demanda arbitral?",
    ImageSrc: "/icos/ico-d-arbitraje.png",
  },
  {
    CardTitle: "Derecho de la Competencia",
    CardDescription:
      "¿Te han denunciado por prácticas anticompetitivas, o buscas cumplir con las normativas de competencia y evitar sanciones?",
    ImageSrc: "/icos/ico-d-competencia2.png",
  },
  {
    CardTitle: "Derecho de Competencia Desleal",
    CardDescription:
      "¿Necesitas proteger tu marca de publicidad engañosa o tu negocio enfrenta prácticas desleales?",
    ImageSrc: "/icos/ico-d-compe-desleal.png",
  },
  {
    CardTitle: "Derecho de Compliance",
    CardDescription:
      "¿Necesitas proteger tu marca de publicidad engañosa o tu negocio enfrenta prácticas desleales?",
    ImageSrc: "/icos/ico-d-compliance.png",
  },
  {
    CardTitle: "Derecho de Propiedad Intelectual",
    CardDescription:
      "¿Quieres registrar una marca, proteger una invención o necesitas ayuda para defenderte de infracciones a tus derechos de autor?",
    ImageSrc: "/icos/ico-d-intelectual.png",
  },

  {
    CardTitle: "Derecho de Tecnología y Datos",
    CardDescription:
      "¿Necesitas asesoría para proteger datos personales, negociar contratos de software, o resolver problemas de ciberseguridad?",
    ImageSrc: "/icos/ico-d-tecnologia.png",
  },
  {
    CardTitle: "Derecho de Salud",
    CardDescription:
      "¿Enfrentas un conflicto de mala praxis médica, necesitas asesoría en seguros de salud, o buscas defender tus derechos como paciente?",
    ImageSrc: "/icos/ico-d-salud.png",
  },
];

export default specialtiesItems;
